import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import NavigationLink from '@cotyorg/ccx-molecules/NavigationLink';

const MobileNavigationVerticalLink = ({
  name,
  pages,
  url,
  openInNewWindow,
  isTopLevel,
  rightChevronIconSrc,
  textExtraId,
  textExtraClass,
}) => {
  const className = classNames('mobile-navigation__link', {
    'mobile-navigation-vertical__link--top-level': isTopLevel,
    'mobile-navigation__link--nested': !isTopLevel,
  });

  return (
    <NavigationLink
      name={name}
      pages={pages}
      url={url}
      openInNewWindow={openInNewWindow}
      extraClass={className}
      textExtraClass={classNames(
        'mobile-navigation-vertical__link-text',
        textExtraClass,
      )}
      iconSrc={rightChevronIconSrc}
      textExtraId={textExtraId}
      doNotLazyLoad={false}
    />
  );
};

MobileNavigationVerticalLink.propTypes = {
  name: PropTypes.string.isRequired,
  url: PropTypes.string,
  openInNewWindow: PropTypes.bool,
  pages: PropTypes.arrayOf(PropTypes.shape({
    slug: PropTypes.string.isRequired,
    name: PropTypes.string.isRequired,
    url: PropTypes.string,
    openInNewWindow: PropTypes.bool,
  })),
  isTopLevel: PropTypes.bool,
  rightChevronIconSrc: PropTypes.string,
  textExtraClass: PropTypes.string,
  textExtraId: PropTypes.string,
};

export default MobileNavigationVerticalLink;
